import React from "react";
import { Link } from "react-router-dom";
import { FiClock } from "react-icons/fi";

const ModalVariant1 = ({ isOpen, onClose, notification }) => {
  if (!isOpen || !notification) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-2xl w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">
            {notification.subject}
          </h2>
          <div className="text-gray-600 text-sm leading-relaxed">
            {notification.message}
          </div>

          <div>
            {notification?.url &&
              (notification.type === "parcel" ? (
                <Link
                  to={`/property-management?type=Parcels`}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 shadow-sm"
                >
                  Go to parcel
                </Link>
              ) : (
                <Link
                  to={notification.url}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 shadow-sm"
                >
                  Go to item
                </Link>
              ))}
          </div>
          <div className="text-xs text-gray-400 flex items-center gap-1">
            <FiClock className="w-4 h-4" />
            {notification.dateTime?.toDate().toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalVariant1;
